import React, { useEffect, useState } from 'react'
import { Button, Modal, Space, Table } from 'antd'
import Icon from '@ant-design/icons'
import { AxiosResponse } from 'axios'
import { faPen, faTrash } from '@fortawesome/free-solid-svg-icons'
import ViewPage from '../../../../Components/ViewPage'
import FormRecomendaTipos from '../../../../Components/recomendacao/ativosTipos'
import {
  delRecomendaAcaoAtivos,
  getRecomendaAcaoAtivos,
  TypeRecomendaAcaoTipos,
} from '../../../../services/recomendacao/ativosTipos'
import { pagination } from '../../../../Components/Default'
import { IconAlert } from '../../../../Components/iconsAlert'
import { Notification } from '../../../../Components/notification'
import Icons from '../../../../Components/Icons'
import { successAlert } from '../../../../utils/alert'

const RecomendaTipos: React.FC = () => {
  const [visibleForm, setVisibleForm] = useState(false)
  const [update, setUpdate] = useState(0)

  const [dataAcaoTipos, setDataAcaoTipos] = useState([])
  const [tempAcaoTipos, setTempAcaoTipos] = useState([])

  const [loadingTable, setLoadingTable] = useState(false)

  const listAcaoAtivos = async () => {
    setLoadingTable(true)
    const resp: AxiosResponse<TypeRecomendaAcaoTipos> = await getRecomendaAcaoAtivos({
      pagination: -1,
    })

    setDataAcaoTipos(resp.data.itens)
    setTempAcaoTipos(resp.data.itens)
    setLoadingTable(false)
  }

  const handleClickNewTipo = () => {
    setVisibleForm(true)
  }

  const handleClickEdit = (cod) => {
    setUpdate(cod)
    setVisibleForm(true)
  }

  const handleSearch = (data) => {
    setLoadingTable(true)
    const dados = dataAcaoTipos
    const nome: any = data.target.value.toLowerCase()

    setTimeout(() => {
      const response = dados.filter((info) => info.nome.toLowerCase().indexOf(nome) !== -1)
      setTempAcaoTipos(response)
      setLoadingTable(false)
    }, 500)
  }

  const handleClickTrash = (cod, nome) => {
    Modal.confirm({
      title: `Deseja remover o ativo ${nome}?`,
      icon: <IconAlert type='confirm' size={6} />,
      okText: 'Sim',
      cancelText: 'Não',
      cancelButtonProps: {
        type: 'primary',
        danger: true,
      },
      onOk: async () => {
        const response = await delRecomendaAcaoAtivos(cod)

        if (response.status === 200) {
          successAlert('Ativo removido com sucesso!');

          listAcaoAtivos()
        }
      },
    })
  }

  const handleCloseForm = (data) => {
    setVisibleForm(data)
    if (data) {
      listAcaoAtivos()
    } else {
      setUpdate(0)
    }
  }

  useEffect(() => {
    listAcaoAtivos()
  }, [])

  return (
    <ViewPage
      title='Tipos de ação para ativos'
      btnClick={handleClickNewTipo}
      search
      inputChange={handleSearch}
      content={
        <FormRecomendaTipos
          onClose={(data) => handleCloseForm(data)}
          visible={visibleForm}
          update={update}
        />
      }
    >
      <Table
        scroll={{ y: 'calc(90vh - 275px)' }}
        rowKey='cod'
        loading={loadingTable}
        size='small'
        dataSource={tempAcaoTipos}
        pagination={pagination}
        columns={[
          {
            key: 1,
            title: 'Nome',
            dataIndex: 'nome',
          },
          {
            key: 2,
            title: 'Tipo',
            dataIndex: 'tipo_nome',
          },
          {
            key: 3,
            title: 'Ações',
            width: 90,
            dataIndex: 'cod',
            render: (data, record) => (
              <Space>
                <Button
                  shape='circle'
                  type='default'
                  onClick={() => handleClickEdit(data)}
                  icon={<Icon component={() => <Icons icon={faPen} />} />}
                />
                <Button
                  shape='circle'
                  type='primary'
                  danger
                  onClick={() => handleClickTrash(data, record.nome)}
                  icon={<Icon component={() => <Icons icon={faTrash} />} />}
                />
              </Space>
            ),
          },
        ]}
        footer={() => (
          <div
            style={{
              display: 'flex',
              width: '100%',
              justifyContent: 'right',
            }}
          >
            <b>Total geral: {dataAcaoTipos.length}</b>
          </div>
        )}
      />
    </ViewPage>
  )
}

export default RecomendaTipos
